var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_758_649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0.558716C11.2089 0.558716 0 11.7676 0 25.5587C0 39.3498 11.2089 50.5587 25 50.5587C38.7911 50.5587 50 39.3498 50 25.5587C50 11.7676 38.7911 0.558716 25 0.558716ZM25 48.0352C12.6174 48.0352 2.52347 37.9413 2.52347 25.5587C2.52347 13.1761 12.6174 3.08219 25 3.08219C37.3826 3.08219 47.4765 13.1761 47.4765 25.5587C47.4765 37.9413 37.3826 48.0352 25 48.0352Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7607 25.4413L34.0964 18.1057C34.5658 17.6362 34.5658 16.8146 34.0964 16.3451C33.6269 15.8756 32.8053 15.8756 32.3358 16.3451L25.0001 23.6808L17.6644 16.3451C17.195 15.8756 16.3734 15.8756 15.9039 16.3451C15.4344 16.8146 15.4344 17.6362 15.9039 18.1057L23.2396 25.4413L15.9039 32.7183C15.4344 33.1878 15.4344 34.0094 15.9039 34.4789C16.1386 34.7136 16.4907 34.831 16.7842 34.831C17.0776 34.831 17.4297 34.7136 17.6644 34.4789L25.0001 27.1432L32.3358 34.4789C32.5705 34.7136 32.9227 34.831 33.2161 34.831C33.5095 34.831 33.8616 34.7136 34.0964 34.4789C34.5658 34.0094 34.5658 33.1878 34.0964 32.7183L26.7607 25.4413Z",
    fill: "#4C4C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.558716)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.aec8fd6c3d2703ea219454e8136f49da.svg";
export { ForwardRef as ReactComponent };